<template>
  <div class="home_wrap">
    <van-row class="topSection">
      <van-col span="4" style="text-align: left">
        <img
          src="../images/common/backArrow.png"
          @click="$router.back()"
          class="imageback"
        />
      </van-col>
      <van-col span="20" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("setBankCard.modifyBankCard")
        }}</span>
      </van-col>
    </van-row>
    <van-row>
      <div class="wrap">
        <!-- ---------- account holder name ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("setBankCard.accountHolderName") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/username.png" alt=""
          /></span>
          <input type="text" v-model="account" />
        </div>
        <!-- ---------- bank card number ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("setBankCard.cardNumber") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/OTP.png" alt=""
          /></span>
          <input type="number" v-model="bankCard" />
        </div>
        <!-- ---------- bank name ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">{{ $t("setBankCard.bankName") }}:</p></van-col
          >
        </van-row>
        <div class="item" @click="showBankPicker = true">
          <span class="icon"
            ><img src="../images/register/OTP.png" alt=""
          /></span>
          <input type="text" v-model="bankName" disabled />
        </div>
        <!-- ---------- bank branch ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"
            ><p class="labelText">
              {{ $t("setBankCard.bankBranch") }}:
            </p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/register/OTP.png" alt=""
          /></span>
          <input type="text" v-model="bankBranch" />
        </div>
        <!-- ------------ confirm button ----------- -->
        <van-row>
          <van-col span="24">
            <div
              class="confirm_btn"
              :class="
                account != '' &&
                bankCard != '' &&
                bankName != '' &&
                bankBranch != ''
                  ? ''
                  : 'no_touch'
              "
              @click="setBankCard()"
            >
              {{ $t("setBankCard.modify") }}
            </div>
          </van-col>
        </van-row>
        <!-- ================= bank name list picker popup ============= -->
        <van-popup v-model="showBankPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="bankList"
            @cancel="showBankPicker = false"
            @confirm="onConfirm"
            :confirm-button-text="$t('bottomSheet.confirmPopup')"
            :cancel-button-text="$t('bottomSheet.cancelPopup')"
          
          />
        </van-popup>
      </div>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Popup, Picker } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Row).use(Col).use(Popup).use(Picker);

export default {
  name: "setbankcard",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      account: "",
      bankCard: "",
      bankName: "",
      bankId: "",
      bankBranch: "",
      showBankPicker: false,
      bankList: [],
      banks:[]
    };
  },
  props: ["bankHas"],
  mounted() {
    
    if (this.bankHas) this.getBankCardDetails();
    this.getBankList();
  },
  methods: {
    onConfirm(bankName, index) {
      this.bankName = bankName;
      this.bankId = this.banks[index].id;
      this.showBankPicker = false;
    },
    setBankCard() {
      Fetch("/finance/changebank", {
        username: this.account,
        bank_account: this.bankCard,
        bank_name: this.bankId,
        bank_branch: this.bankBranch,
      }).then((r) => {
        this.$toast.success();
      });
    },
    getBankCardDetails() {
      Fetch("/finance/user_bank_list", {
        type: 1,
      }).then((res) => {
        this.account = res.data.name;
        this.bankBranch = res.data.area;
        this.bankCard = res.data.account;
        this.bankName = res.data.bank_types[this.lang];
        this.bankId = res.data.bank_types.id;
      });
    },
    getBankList() {
      Fetch("/finance/bank_types").then((res) => {
        this.banks = res.data;
        res.data.forEach((item) => {
          this.bankList.push(item[this.lang]);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 30px;
  width: auto;
}

.no_touch {
  pointer-events: none;
}

.wrap {
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 25px 15px;
  background: #ebebeb29;
  margin: 10px;
}

.confirm_btn.no_touch {
  color: rgba(255, 255, 255, 0.5);
}

.confirm_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 60px;
  background: linear-gradient(
    117deg,
    rgba(254, 166, 0, 1) 0%,
    rgba(255, 188, 0, 1) 100%
  );
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;
  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
      height: 27px;
    }
  }
  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}
</style>
